import { PROJECT_EDIT_POPUP } from '../../actions/actionsNamesList';

const {
    OPEN, CLOSE, SET_DATA
} = PROJECT_EDIT_POPUP;

const defaultState = {
    isOpened: false,
    id: null,
    name: '',
    initialName: '',
    isNameUnique: false,
    isNameUniquenessChecking: false,
    customerViewCompanyId: null,
    description: ''
};

export default function projectEditPopupData(state = defaultState, action) {
    switch (action.type) {
        case OPEN: {
            return {
                ...state,
                isOpened: true
            };
        }
        case CLOSE: {
            return {
                ...state,
                isOpened: false
            };
        }
        case SET_DATA: {
            return {
                ...state,
                ...action.data
            };
        }
        default: {
            return { ...state };
        }
    }
}